<style lang="scss" scoped>
.star-score {
    display: flex;

    ::v-deep {
        svg {
            margin-right: 4px;

            &:last-child {
                margin-right: 0px;
            }
        }
    }

    span.clickable {
        cursor: pointer;
    }

    &.large {
        ::v-deep {
            svg {
                width: 24px;
                height: 24px;
                margin-right: 6px;
            }
        }
    }
}
</style>

<template>
    <div class="star-score" :class="{large: large}">
        <template v-if="!input">
            <template v-for="i in Math.floor(selectedScore)">
                <span :key="`full.${i}`" v-html="svg('star-solid-primary')"></span>
            </template>
            <template v-if="selectedScore - Math.floor(selectedScore) > 0">
                <span key="half" v-html="svg('star-half-primary')"></span>
            </template>
            <template v-for="i in (5 - Math.ceil(selectedScore))">
                <span :key="`blank.${i}`" v-html="svg('star-solid-gray')"></span>
            </template>
        </template>
        <template v-else>
            <span v-for="i in 5" :key="i" class="clickable" v-html="svg(getStarType(i))" @mouseover="mouseover(i)" @mouseleave="mouseleave" @click="submitScore(i)"></span>
        </template>
    </div>
</template>

<script>
export default {
    name: "Ui.ScoreStars",

    props: {
        score: {
            type: Number,
            required: true
        },

        input: {
            type: Boolean,
            required: false,
            default: false,
        },

        large: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            hovering: false,
            hoverScore: 5,
            selectedScore: 5,
        }
    },

    mounted() {
        this.hoverScore = this.score;
        this.selectedScore = this.score;
    },

    methods: {
        mouseover(i) {
            this.hovering = true;
            this.hoverScore = i;
        },

        mouseleave() {
            this.hovering = false;
        },

        submitScore(i) {
            this.selectedScore = i;
            this.$emit('score-stars-input', this.selectedScore);
        },

        getStarType(i) {
            let score = this.hovering ? this.hoverScore : this.selectedScore;

            if (i <= score) {
                return 'star-solid-primary';
            } else if (i > score) {
                return 'star-solid-gray';
            }
        }
    }
}
</script>